@if (config()) {
  <button
    matRipple
    tab
    [matTooltip]="titleTranslationKey() | transloco"
    (click)="taskIconClicked.emit()"
    (keypress)="taskIconClicked.emit()"
    [class.selected]="config().Selected"
    tabindex="0"
    class="cursor-pointer"
  >
    <mat-icon class="text-primary-accumin-purple-100" [svgIcon]="config().MatIcon" />
  </button>
}
